'use strict';

import BankAccount from 'newModels/bank-account.js';
import BankAccountModal from 'commons/views/BankAccountModal';
import loader from 'helpers/loader';

module.exports = {
    events: function() {
        return {
            'click .js-add-bank-account':  'addBankAccount',
            'click .js-edit-bank-account': 'editBankAccount'
        };
    },

    initialize: function() {
        this.bankAccountModal = new BankAccountModal({
            actOnSave: false,
            actOnCancel: false,
            actOnDestroy: false
        });
        this.bindBankAccountModalHandlers();
    },

    bindHandlers: function() {
        this.bindBankAccountModalHandlers();
    },

    unbindHandlers: function() {
        this.unbindBankAccountModalHandlers();
    },

    bindBankAccountModalHandlers: function() {
        if (this.bankAccountModal) {
            this.bankAccountModal.on('saved', this.renderBankAccount, this);
            this.bankAccountModal.on('cancelled', this.resetBankAccount, this);
            this.bankAccountModal.on(
                'destroyed', this.destroyBankAccount, this
            );
            this.bankAccountModal.on(
                'saved cancelled destroyed', this.toggleButtons, this
            );
        }
    },

    unbindBankAccountModalHandlers: function() {
        if (this.bankAccountModal) {
            this.bankAccountModal.off(null, null, this);
        }
    },

    destroyBankAccount: function(bankAccount) {
        const stopLoader = loader.startFullScreen();

        this.bankAccountModal.unsetModel();

        if (bankAccount.isNew()) {
            stopLoader();
            return this.renderBankAccount(null);
        }

        return bankAccount.destroy()
            .then(() => {this.model.setBankAccount(null);})
            .then(() => this.model.save({bankAccountId: null}))
            .then(() => this.renderBankAccount(null))
            .finally(() => stopLoader);
    },

    resetBankAccount: function(bankAccount) {
        var stopLoader = loader.startFullScreen();

        if (!bankAccount.isNew()) {
            bankAccount.fetch()
                .then(() => this.renderBankAccount(bankAccount))
                .finally(() => stopLoader());
        }
    },

    renderBankAccount: function(bankAccount) {
        if (
            !bankAccount ||
            !this.model.getBankAccount() ||
            this.model.getBankAccount().id !== bankAccount.id
        ) {
            this.model.setBankAccount(bankAccount);
        }

        if (!_.isNull(bankAccount)) {
            this.bankAccountModal.enableDestroyButton();
        } else {
            this.bankAccountModal.disableDestroyButton();
        }

        return this.render();
    },

    addBankAccount: function() {
        this.showEditBankAccountModal(new BankAccount(
            this.options.bankAccountOverrides || {}
        ));
    },

    editBankAccount: function() {
        this.showEditBankAccountModal(this.model.getBankAccount());
    },

    showEditBankAccountModal: function(bankAccount) {
        this.bankAccountModal.setModel(bankAccount).render().show();
    }
};



// WEBPACK FOOTER //
// ./app/commons/viewMixins/BankAccount.js